import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectDepartmentsListItems } from "../../../../../../redux/departments/selector";
import { departments } from "../../../../../../redux/departments/action";
import { selectListItems } from "../../../../../../redux/library/selector";
import { creditDebitNotes } from "../../../../../../redux/credit-debit-notes/action";
import { selectCreditDebitNotesListItems } from "../../../../../../redux/credit-debit-notes/selector";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const ManagementCreditDebitNotes = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const libraryData = useSelector(selectListItems)
    const creditDebitItemsData = useSelector(selectCreditDebitNotesListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'NoteNumber', headerName: 'Note Number',searchField: 'NoteNumber', sortable: true, filter: true, filterType: 'text' },
            {
                field: 'ReferenceTypeId',
                headerName: 'Reference Type',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CreditDebitNoteReferenceType }
            },
            {
                field: 'DocumentTypeId',
                headerName: 'Document Type',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CreditDebitNoteDocumentType }
            },
            { field: 'SupplierId', headerName: 'Supplier' },
            { field: 'Amount', headerName: 'Amount', isCurrencyValueFormat: true },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    }

    const fetchCreditDebitNotesList = () => {
        dispatch(creditDebitNotes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/credit-debit-notes/list`,
            entity: 'creditDebitNotes',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
            }
        }))
    }

    useEffect(() => {
        createColumnDefs()
        fetchCreditDebitNotesList()
    }, [pageData, pageSize])

    const handleAdd = () => {
        navigate(`${0}`)
    }

    

    const handleDelete = (data: any) => {
        dispatch(creditDebitNotes.delete({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/credit-debit-notes/delete`,
            entity: 'creditDebitNotes',
            jsonData: {
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        })).then(() => {
            fetchCreditDebitNotesList()
        });
    }

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
      }
      const handleReloadData = () => {
        fetchCreditDebitNotesList()
      }
      const additionButtons: any = [
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <title>Add Credit/Debit Notes</title>
              <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>,
          callback: () => handleAdd(),
        },
        
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <title>Reload this table</title>
              <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
          callback: () => handleReloadData(),
        },
      ];
    
      const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "NoteNumber",
            FieldText: "NoteNumber",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } 

        dispatch(creditDebitNotes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/credit-debit-notes/list`,
            entity: 'creditDebitNotes',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
              }
        }))
    }

    // const additionButtons: any = [
    //     {
    //         name: 'Add Credit/Debit Notes',
    //         callback: () => handleAdd(),
    //     }
    // ];

   

    const handleRefundAmount = async (dataId: any) => {
        dispatch(creditDebitNotes.update({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/credit-debit-notes/refund`,
            entity: 'creditDebitNotes',
            jsonData: {
                Records: [
                    {
                        Id: dataId.Id,
                    }
                ]
            }
        })).then(() => {
            dispatch(creditDebitNotes.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/credit-debit-notes/list`,
                entity: 'creditDebitNotes',
                jsonData: {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                }
            }))
        });
    }

    

    return (
        <>
            {creditDebitItemsData?.isLoading ?
                <PageLoader /> :
                <Table 
                checkboxConfig={{
                    allowMultiSelect: true,
                    defaultSelectedIds: [],
                    isDisabled: false,
                    keyColumn: 'Id',
                  }}
                columnData={columnDefs} rowData={creditDebitItemsData?.result?.items} setPageData={setPageData}
                    setPageSize={setPageSize} paginationData={creditDebitItemsData?.result?.pagination}
                    IsMoreActionsCreditDebitNotes={true} handleCreditDebitNotesRefundAmountPage={handleRefundAmount}
                    enableFilter={true} onSearch={handleSearch} additionButtons={additionButtons} onEdit={handleEdit} onDelete={handleDelete}
                    headingName="Credit / Debit Notes" />
            }
        </>
    );
};

export default ManagementCreditDebitNotes;



